import {Ref} from "react";

export default function fillRef<T>(ref: Ref<T>, node: T) {
    if (typeof ref === 'function') {
        ref(node);
        return;
    }
    if (ref && 'current' in ref) {
        (ref as any).current = node;
        return;
    }
}